import { LoginService } from "./services/login.service";

export function initialiseData(loginService: LoginService) {
    return () => {
        return loginService.validateToken(false);
    }
}